import { WIDGET_SIGNATURES } from "@/utils/widgets";

const COLS = Object.freeze({
    THIRD: { xl: 3, lg: 3, md: 12, sm: 12 },
    THIRD_WIDE_LG: { xl: 3, lg: 6, md: 12, sm: 12 },
    ONE_THIRD: { xl: 4, lg: 4, md: 12, sm: 12 },
    HALF: { xl: 6, lg: 12, md: 12, sm: 12 },
    THREE_QUARTERS: { xl: 9, lg: 12, md: 12, sm: 12 },
    FULL: { xl: 12, lg: 12, md: 12, sm: 12 },
});

const DEFAULTS = Object.freeze({
    hidden: false,
    cols: COLS.THIRD_WIDE_LG,
    order: 1000,
    wrapInCard: true,
});

const ORDER = [
    WIDGET_SIGNATURES.participating_customers_widget,
    WIDGET_SIGNATURES.points_credit_widget,
    WIDGET_SIGNATURES.overview_bonus_credit_widget,
    WIDGET_SIGNATURES.overview_bonus_credit_widget_extended,
    WIDGET_SIGNATURES.score_widget,
    WIDGET_SIGNATURES.brand_rim_widget,
    WIDGET_SIGNATURES.season_business_units_widget,
    WIDGET_SIGNATURES.brand_widget,
    WIDGET_SIGNATURES.rim_widget,
    WIDGET_SIGNATURES.dealer_performance_widget,
    WIDGET_SIGNATURES.overview_amount_of_tires_widget,
    WIDGET_SIGNATURES.dealer_combined_achievement_goals_widget,
    WIDGET_SIGNATURES.booster_ccs_widget,
    WIDGET_SIGNATURES.business_unit_widget,
    WIDGET_SIGNATURES.score_widget_extended,
    WIDGET_SIGNATURES.last_import_widget,
    WIDGET_SIGNATURES.dealer_list_widget,
    WIDGET_SIGNATURES.wholesaler_list_widget,
]

const WIDGETS = {
    [WIDGET_SIGNATURES.brand_widget]: {
        cols: COLS.THIRD_WIDE_LG,
    },
    [WIDGET_SIGNATURES.overview_amount_of_tires_widget]: {
        cols: COLS.THIRD_WIDE_LG,
        colsIf: COLS.ONE_THIRD,
    },
    [WIDGET_SIGNATURES.overview_bonus_credit_widget]: {
        cols: COLS.THIRD_WIDE_LG,
    },
    [WIDGET_SIGNATURES.participating_customers_widget]: {
        cols: COLS.THIRD_WIDE_LG,
        colsIf: COLS.ONE_THIRD,
    },
    [WIDGET_SIGNATURES.points_credit_widget]: {
        cols: COLS.THIRD_WIDE_LG,
        colsIf: COLS.ONE_THIRD,
    },
    [WIDGET_SIGNATURES.rim_widget]: {
        cols: COLS.THIRD_WIDE_LG,
    },
    [WIDGET_SIGNATURES.brand_rim_widget]: {
        cols: COLS.HALF,
    },
    [WIDGET_SIGNATURES.score_widget]: {
        cols: COLS.THIRD,
    },
    [WIDGET_SIGNATURES.dealer_combined_achievement_goals_widget]: {
        cols: COLS.THREE_QUARTERS,
    },
    [WIDGET_SIGNATURES.dealer_performance_widget]: {
        cols: COLS.THIRD_WIDE_LG,
        colsIf: COLS.ONE_THIRD,
    },
    [WIDGET_SIGNATURES.booster_ccs_widget]: {
        cols: COLS.FULL,
    },
    [WIDGET_SIGNATURES.last_import_widget]: {
        cols: COLS.FULL,
        wrapInCard: false,
    },
    [WIDGET_SIGNATURES.score_widget_extended]: {
        cols: COLS.ONE_THIRD,
    },
    [WIDGET_SIGNATURES.business_unit_widget]: {
        cols: COLS.THIRD,
    },
    [WIDGET_SIGNATURES.season_business_units_widget]: {
        cols: COLS.HALF,
    },
    [WIDGET_SIGNATURES.overview_bonus_credit_widget_extended]: {
        cols: COLS.THIRD,
        hidden: true,
    },
    [WIDGET_SIGNATURES.dealer_list_widget]: {
        cols: COLS.FULL,
        wrapInCard: false,
    },
    [WIDGET_SIGNATURES.wholesaler_list_widget]: {
        cols: COLS.FULL,
        wrapInCard: false,
    },
};

const DASHBOARD_CONFIG = {
    order: ORDER,
    defaults: DEFAULTS,
    widgets: WIDGETS,
};

export default DASHBOARD_CONFIG;